<template>
  <iframe :src="viewerUrl" width="100%" height="100%"/>
</template>

<script>
import { mapState } from 'vuex';
import 'pdfjs-dist/web/pdf_viewer.css';
import pdfjsLib from 'pdfjs-dist/webpack';
/* import {
  DefaultAnnotationLayerFactory, DefaultTextLayerFactory, PDFLinkService, PDFPageView,
} from 'pdfjs-dist/web/pdf_viewer.js';
 */

pdfjsLib.GlobalWorkerOptions.workerSrc = '../../build/browserify/pdf.worker.bundle.js';
export default {
  name: 'PDF',
  components: {
  },
  props: ['pdfUrl'],
  data: () => ({
    viewerUrl: undefined,
  }),
  computed: mapState([
    'runInfo',
  ]),
  watch: {
    pdfUrl() {
      this.fetchPdf()
    }
  },
  methods: {
    fetchPdf() {
      console.log('runInfo', this.runInfo);
      this.$apiRequest.getBlobByPost('/Documents', { fileUrl: this.pdfUrl } ).then(async (pdfDocumentRaw) => {
        // const container = document.getElementById('viewerContainer');
        // const canvas = document.getElementById('canvas');
        console.log('pdf', pdfDocumentRaw);

        // create url from uintarray
        console.log('pdf', typeof pdfDocumentRaw, pdfDocumentRaw instanceof Blob, pdfDocumentRaw instanceof Uint8Array);
        const fileUrl = encodeURIComponent(URL.createObjectURL(pdfDocumentRaw));
        this.viewerUrl = `pdfViewer/web/viewer.html?file=${fileUrl}&beforePrint=false&startDownload=null`;
        // render viewerfolder
      });


      /* pdfjsLib.getDocument({data: pdfDocumentRaw}).promise.then(pdfDocument => pdfDocument.getPage(1).then((pdfPage) => {
          const viewport = pdfPage.getViewport({ scale: 1.0 });
          console.log('pdf', 'display');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          const renderTask = pdfPage.render({
            viewport,
            canvasContext: canvas.getContext('2d'),
          });
          return renderTask.promise;
          // pdfViewer.setDocument(pdfDocument);
        })).catch((e)=> {
          console.error('error rendering',e);
        });
      }); */
    },
  },
  mounted() {
    this.fetchPdf();
  },
  beforeDestroy() {

  },
};
</script>
